import { useQuery } from "@tanstack/react-query"
import { parseResponse } from "@/core/data/parse-response"
import { fetchWithAuth } from "@/core/data/fetch-with-auth"
import type { SynthesisMetadataModel } from "../../data/models/synthesis-session-model"

const fetchLlm = async () => {
  const res = await fetchWithAuth("/api/v1/metadata")
  const data = await parseResponse<SynthesisMetadataModel>(res)
  return data.llm ?? []
}

export const useLlmOptions = () =>
  useQuery({
    queryKey: ["synthesis-llm-options"],
    queryFn: fetchLlm,
    staleTime: Infinity,
  })
